import { createContext } from 'react';

import { ModalContextValue } from '../types';

function invalidMethod(..._args: unknown[]): unknown {
    throw new Error('Use ClinicInfoContext outside of Provider');
}

export const clinicInfoContext = createContext<ModalContextValue>({
    isOpen: null!,
    setOpen: invalidMethod,
});
